import { OffersDeliveryDatesState } from './../reducers/offers.delivery.dates.reducer';
import { VIEW_OFFERS_FEATURE } from '../reducers/index';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromDeliveryDates from '../reducers/offers.delivery.dates.reducer';
import * as fromOffer from '@view-offers/store/reducers';

const selectOffersState =
  createFeatureSelector<fromOffer.ViewOffersState>(VIEW_OFFERS_FEATURE);

export const selectOffersDeliveryDatesState = createSelector(
  selectOffersState,
  (state) => {
    return state.offersDeliveryDates;
  }
);

export const selectOffersDeliveryDatesKeys = createSelector(
  selectOffersDeliveryDatesState,
  fromDeliveryDates.selectOffersDeliveryDatesIds
);
export const selectOffersDeliveryDatesEntities = createSelector(
  selectOffersDeliveryDatesState,
  fromDeliveryDates.selectOffersDeliveryDatesEntities
);
export const selectOffersDeliveryDates = createSelector(
  selectOffersDeliveryDatesState,
  fromDeliveryDates.selectOffersDeliveryDates
);

export const selectEntityById =
  (id: string) => (state: OffersDeliveryDatesState) =>
    state.entities[id];

export const selectOffersDeliveryDatesById = (id: string) =>
  createSelector(selectOffersDeliveryDatesState, selectEntityById(id));
